const en = {
  app: {
    name: 'W&M',
    fullName: 'W&M Vending',
    tagline: 'Vending operations',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    search: 'Search',
    actions: 'Actions',
    total: 'Total',
    all: 'All',
    refresh: 'Refresh',
    retry: 'Try again',
    exportCsv: 'Export CSV',
    viewAll: 'View all',
    open: 'Open',
    more: 'More',
    loading: 'Loading…',
    currency: 'UZS',
    pcs: 'pcs',
    days: 'days',
    noValue: '—',
    optional: 'optional',
  },
  nav: {
    sectionMain: 'Overview',
    sectionManage: 'Management',
    dashboard: 'Dashboard',
    checkout: 'Cash desk',
    reports: 'Reports',
    createReport: 'Submit report',
    users: 'Staff',
    branches: 'Branches',
    products: 'Inventory',
    collapse: 'Collapse sidebar',
    expand: 'Expand sidebar',
    openMenu: 'Open menu',
    home: 'Home',
  },
  header: {
    breadcrumb: 'Breadcrumb',
    search: 'Search…',
    searchShortcut: 'Ctrl K',
    notifications: 'Notifications',
    noNotifications: 'No new notifications',
    allGood: 'All good',
    lowStockItem: '{{count}} pcs left in stock',
    outOfStockItem: 'Out of stock',
    theme: 'Theme',
    language: 'Language',
    profile: 'Profile',
    editProfile: 'Edit profile',
    logout: 'Sign out',
    administrator: 'Administrator',
    employee: 'Employee',
  },
  theme: {
    system: 'System',
    light: 'Light',
    dark: 'Dark',
    night: 'Night',
  },
  search: {
    placeholder: 'Search pages, products, branches or staff…',
    pages: 'Pages',
    products: 'Products',
    branches: 'Branches',
    users: 'Staff',
    empty: 'No results found',
    hintNavigate: 'navigate',
    hintOpen: 'open',
    hintClose: 'close',
  },
  filters: {
    period: 'Period',
    today: 'Today',
    yesterday: 'Yesterday',
    last7: '7 days',
    last30: '30 days',
    thisMonth: 'This month',
    custom: 'Custom',
    branch: 'Branch',
    allBranches: 'All branches',
    product: 'Product',
    allProducts: 'All products',
    productsSelected: '{{count}} products',
    startDate: 'Start date',
    endDate: 'End date',
    reset: 'Reset filters',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Sales, inventory and branches at a glance',
    kpi: {
      revenue: 'Total revenue',
      today: 'Revenue today',
      units: 'Units sold',
      profit: 'Gross profit',
      avgDaily: 'Average daily revenue',
      stock: 'Units in stock',
      lowStock: 'Low-stock products',
      branches: 'Branches with sales',
    },
    vsPrevious: 'vs previous period',
    vsYesterday: 'vs yesterday',
    noComparison: 'No data to compare',
    skuCount: '{{count}} products',
    lowStockHint: '{{count}} pcs or fewer',
    branchesHint: 'out of {{count}} branches',
    margin: 'Margin: {{value}}',
    daysWithSales: '{{count}} days with sales',
    productFilterNote: 'Product filter not applied',
    allInStock: 'All products are well stocked',
    openReports: 'Detailed report',
  },
  charts: {
    salesDynamics: 'Sales trend',
    salesDynamicsSub: 'Daily, compared with the previous period',
    current: 'Current period',
    previous: 'Previous period',
    revenue: 'Revenue',
    profit: 'Profit',
    units: 'Units sold',
    cost: 'Cost of goods',
    revenueVsCost: 'Revenue and cost',
    revenueVsCostSub: 'Revenue = cost of goods + gross profit',
    byBranch: 'Revenue by branch',
    byBranchSub: 'Branch share for the selected period',
    topProducts: 'Top 5 products',
    topProductsSub: 'By units sold',
    productShare: 'Product mix',
    productShareSub: 'Share of units sold',
    others: 'Others',
    share: 'Share',
    totalUnits: 'total units',
    dailyProfit: 'Daily profit',
    productProfit: 'Profit by product',
    singleBranch: 'Select “All branches” to compare branches',
  },
  tables: {
    recentDays: 'Recent sales days',
    recentDaysSub: 'Daily revenue, units and profit',
    date: 'Date',
    lowStock: 'Low-stock products',
    lowStockSub: '{{count}} pcs or fewer left in stock',
    remaining: 'In stock',
    rowsTotal: '{{from}}–{{to}} of {{total}}',
  },
  states: {
    emptyTitle: 'No data found',
    emptyPeriod: 'No sales were recorded in this period',
    emptyHint: 'Try another period or branch',
    emptySearch: 'No matching results',
    emptySearchHint: 'Try a different search',
    errorTitle: 'Couldn’t load data',
    errorHint: 'Something went wrong while contacting the server. Please try again.',
  },
  checkout: {
    title: 'Cash desk',
    subtitle: 'Daily revenue — {{branch}}',
    total: 'Period total',
    avgDay: 'Daily average',
    bestDay: 'Best day',
    days: 'Days with sales',
    daily: 'Daily revenue',
    dailySub: 'Cash received each day',
  },
  reports: {
    title: 'Reports',
    titleFor: '{{branch}} report',
    subtitle: 'Sales by product and day',
    productName: 'Product',
    quantity: 'Qty',
    profit: 'Profit',
    overall: 'Total',
    total: 'Total',
    exportName: 'report',
  },
  createReport: {
    title: 'Submit report',
    subtitle: 'Enter the products sold by a branch for the day',
    branch: 'Branch',
    branchPlaceholder: 'Select a branch',
    date: 'Date',
    searchProduct: 'Search products',
    searchPlaceholder: 'Product name',
    soldQuantity: 'Units sold',
    products: 'Products',
    filled: '{{count}} products entered',
    totalUnits: 'Total: {{count}} pcs',
    negativeError: 'Units sold can’t be less than 0',
    inStock: 'In stock: {{count}}',
  },
  users: {
    title: 'Staff',
    subtitle: 'System users and their branches',
    add: 'Add employee',
    name: 'Employee',
    branches: 'Assigned branches',
    noBranches: 'No branches assigned',
    searchPlaceholder: 'Search staff',
    createTitle: 'New employee',
    createSubtitle: 'Create a login and password for system access',
    editTitle: 'Update details',
    editSubtitle: 'Change login, email and password',
    login: 'Login',
    loginPlaceholder: 'Enter login',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    emailHint: 'A password reset code will be sent to this address',
    emailInvalid: 'Invalid email',
    noEmail: 'No email',
    emailMissingTitle: 'Add your email',
    emailMissingText: 'No email is set. If you forget your password, you won’t be able to reset it.',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    newPasswordHint: 'Leave blank to keep the current password',
    loginMin: 'Login must be at least 4 characters',
    passwordMin: 'Password must be at least 4 characters',
    pages: 'Page access',
    pagesHint: 'The employee can only see the checked pages',
    pagesRequired: 'Select at least one page',
    count: '{{count}} employees',
  },
  branches: {
    title: 'Branches',
    subtitle: 'Sales points, assigned staff and prices',
    add: 'Add branch',
    name: 'Branch name',
    namePlaceholder: 'e.g. Chilonzor branch',
    staff: 'Assigned staff',
    staffPlaceholder: 'Select employees',
    noStaff: 'No staff assigned',
    prices: 'Prices',
    reports: 'Reports',
    searchPlaceholder: 'Search branches',
    createTitle: 'New branch',
    createSubtitle: 'Enter a name and assign staff',
    editTitle: 'Edit branch',
    editSubtitle: 'Branch name and assigned staff',
    pricesTitle: '{{branch}} — prices',
    pricesSubtitle: 'Selling prices of products in this branch',
    editPrices: 'Edit prices',
    editPricesTitle: '{{branch}} — edit prices',
    editPricesSubtitle: 'Set the selling price for each product',
    sellPrice: 'Selling price',
    pricePlaceholder: 'Price',
    count: '{{count}} branches',
  },
  products: {
    title: 'Inventory',
    subtitle: 'Products, stock levels and branch prices',
    create: 'New product',
    addStock: 'Receive stock',
    name: 'Product name',
    namePlaceholder: 'Enter product name',
    searchPlaceholder: 'Search products',
    stock: 'In stock',
    buyPrice: 'Purchase price',
    buyPricePlaceholder: 'Enter price',
    quantity: 'Quantity',
    quantityPlaceholder: 'Enter quantity',
    branchPrices: 'Selling prices by branch',
    branchPricesHint: 'Set the selling price for each branch',
    searchBranch: 'Search branches',
    sellPrice: 'Selling price',
    createTitle: 'New product',
    createSubtitle: 'Product details and branch prices',
    editTitle: 'Edit product',
    editSubtitle: 'Product details and branch prices',
    addStockTitle: 'Receive stock',
    addStockSubtitle: 'Enter the received quantity for each product',
    addQuantity: 'Received quantity',
    currentStock: 'Current stock: {{count}}',
    negativeError: 'Quantity can’t be less than 0',
    statusOk: 'In stock',
    statusLow: 'Low stock',
    statusOut: 'Out of stock',
    count: '{{count}} products',
    filterAll: 'All',
    filterLow: 'Low stock',
    general: 'General',
  },
  confirm: {
    deleteTitle: 'Confirm deletion',
    deleteText: 'Are you sure you want to delete this? This action can’t be undone.',
  },
  notify: {
    created: '{{entity}} created successfully',
    updated: '{{entity}} updated successfully',
    deleted: '{{entity}} deleted successfully',
    added: '{{entity}} added successfully',
    createError: 'Failed to create {{entity}}',
    updateError: 'Failed to update {{entity}}',
    deleteError: 'Failed to delete {{entity}}',
    addError: 'Failed to add {{entity}}',
    loginSuccess: 'Welcome back!',
    loginError: 'Incorrect login or password',
    logoutSuccess: 'You have signed out',
    logoutError: 'Failed to sign out',
    entities: {
      user: 'Employee',
      branch: 'Branch',
      product: 'Product',
      report: 'Report',
      prices: 'Prices',
    },
  },
  validation: {
    required: '“{{field}}” is required',
    min: 'Enter at least {{count}} characters',
    nonNegative: 'Value can’t be less than 0',
    number: 'Enter a number',
  },
  login: {
    title: 'Sign in',
    subtitle: 'Sign in to your account to continue',
    login: 'Login',
    loginPlaceholder: 'Enter your login',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    submit: 'Sign in',
    forgotPassword: 'Forgot password?',
    asideTitle: 'Run your vending network from a single dashboard',
    asideText: 'Revenue, stock levels and branch performance in real time.',
    feature1: 'Daily revenue and profit analytics',
    feature2: 'Inventory level control',
    feature3: 'Branch-level reporting',
  },
  forgotPassword: {
    title: 'Reset password',
    subtitle: 'Enter the email linked to your account and we will send you a 6-digit verification code',
    email: 'Email',
    emailPlaceholder: 'example@mail.com',
    submit: 'Send code',
    backToLogin: 'Back to sign in',
    codeTitle: 'Enter the code',
    codeText: 'A 6-digit verification code has been sent to:',
    codeHint: 'The code is valid for 15 minutes. If you don’t see the email, check your Spam folder.',
    verify: 'Verify',
    resend: 'Resend code',
    resendIn: 'Resend ({{count}} s)',
    changeEmail: 'Use a different email',
  },
  resetPassword: {
    title: 'Set a new password',
    subtitle: 'Choose a new, strong password for your account',
    password: 'New password',
    passwordPlaceholder: 'Enter new password',
    confirm: 'Confirm password',
    confirmPlaceholder: 'Re-enter password',
    confirmRequired: 'Re-enter your password',
    mismatch: 'Passwords do not match',
    ruleLength: 'At least 8 characters',
    ruleLetter: 'At least one letter',
    ruleDigit: 'At least one digit',
    submit: 'Save password',
    successTitle: 'Password updated',
    successText: 'You can now sign in with your new password.',
  },
  errors: {
    network: 'No connection to the server. Check your internet connection',
    unknown: 'An unexpected error occurred. Please try again',
    too_many_requests: 'Too many attempts. Try again in a minute',
    email_required: 'Enter your email',
    email_invalid: 'Invalid email',
    email_email: 'Invalid email',
    email_max: 'Email is too long',
    email_unique: 'This email is already assigned to another employee',
    email_not_found: 'This email is not registered in the system',
    mail_failed: 'Could not send the email. Please try again later',
    login_required: 'Enter a login',
    login_min: 'Login must be at least 4 characters',
    login_unique: 'This login is taken, choose another one',
    password_required: 'Enter a password',
    password_min: 'Password must be at least 4 characters',
    password_weak: 'Password must be at least 8 characters and contain letters and digits',
    user_not_found: 'User not found',
    wrong_password: 'Incorrect password',
    code_required: 'Enter the full 6-digit code',
    code_invalid: 'Incorrect code. Check the code in the email and try again',
    code_expired: 'The code has expired. Please request a new one',
    code_attempts_exceeded: 'Too many incorrect attempts. For security the code was cancelled — request a new one',
  },
  notFound: {
    title: 'Page not found',
    text: 'The page you’re looking for doesn’t exist or has been moved.',
    home: 'Back to dashboard',
  },
  errorBoundary: {
    title: 'Something went wrong',
    text: 'Try reloading the page. If the problem persists, contact your administrator.',
    reload: 'Reload',
  },
  table: {
    sortAsc: 'Sort ascending',
    sortDesc: 'Sort descending',
    cancelSort: 'Clear sorting',
  },
};

export default en;
